import React from "react";

interface GoogleMapProps {
  query: string;
  title: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ query, title }) => {
  const apiKey: string | undefined = process.env.REACT_APP_GOOGLE_MAPS_KEY;

  return (
    <iframe
      title={title}
      src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${query}`}
      style={{ border: 0, width: "100%", height: "100%" }}
      allowFullScreen
      loading="lazy"
    />
  );
};

export default GoogleMap;
